var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_vm._m(0),_c('div',{staticClass:"border-b pb-lg mb-lg"},[_c('basic-info')],1),_c('div',{staticClass:"pb-lg mb-lg"},[_c('reset-password')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-mobile is-vcentered"},[_c('div',{staticClass:"column"},[_c('h4',{staticClass:"is-size-4 mb-lg"},[_vm._v("User Settings")])])])
}]

export { render, staticRenderFns }